module.exports = __webpack_public_path__ + "static/media/info_icon-white.dd2248f6.svg";